import type { TFunction } from 'i18next';

import yup from '../../../shared/validation';

export function getNewTrainingFormValidation(t: TFunction) {
  return yup.object({
    createForOthers: yup.boolean(),
    trainingOwner: yup
      .object()
      .nullable()
      .test(
        'training-owner-when-for-others',
        t('trainings.trainingOwnerRequired'),
        function trainingOwnerRequired(value) {
          const { createForOthers } = this.parent as {
            createForOthers?: boolean;
          };
          if (createForOthers) {
            return (
              value != null && typeof (value as { id?: string }).id === 'string'
            );
          }
          return true;
        },
      ),
  });
}
